<div mat-dialog-title>
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <i class="i-16 mr-8 {{titleIcon ?? 'fas fa-sync-alt fa-spin'}}"></i>
      <span>{{title}}</span>
    </div>
  </div>
</div>
<div mat-dialog-content class="text-center">
  <p class="c-grey-5 fs-14 ws-pre">{{message}}</p>
  <div>
    <app-spinner></app-spinner>
  </div>
</div>
